import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import QAOffering from "@/pages/QAOffering";

export const Route = createFileRoute("/zh-cn/services/quality-assurance/qa-consultancy-apr-pqr")({
  head: () => buildRouteHead("/zh-cn/services/quality-assurance/qa-consultancy-apr-pqr"),
  component: QAOffering,
});
